/**
 * 帮助手册相关接口
 */
import request from '@/utils/request'
import baseUrl from '@/utils/baseUrl'

/**
 * 获取帮助文章列表
 * @param {Object} params - 查询参数
 * @param {Number} params.page - 页码（从0开始）
 * @param {Number} params.pageSize - 每页数量
 * @param {String} params.keyword - 搜索关键词（可选）
 */
export function getHelpList(params) {
  const page = Number(params.page)
  const pageSize = Number(params.pageSize)
  return request({
    url: '/vportal/helpCenter/manage/page',
    baseURL: baseUrl.apiBaseAuth,
    method: 'get',
    params: {
      page: Number.isFinite(page) && page >= 0 ? page : 0,
      pageSize: Number.isFinite(pageSize) && pageSize > 0 ? pageSize : 10
      // 注意：根据实际接口文档，如果有 keyword 参数，需要添加
      // keyword: params.keyword || ''
    }
  })
}

/**
 * 获取帮助文章详情
 * @param {String} id - 文章ID
 */
export function getHelpDetail(id) {
  return request({
    url: `/pcs/help/${id}`,
    method: 'get'
  })
}

export default {
  getHelpList,
  getHelpDetail
}
